import { render } from "./SearchTopSuggest.vue?vue&type=template&id=67956438&scoped=true"
import script from "./SearchTopSuggest.vue?vue&type=script&lang=js"
export * from "./SearchTopSuggest.vue?vue&type=script&lang=js"

import "./SearchTopSuggest.vue?vue&type=style&index=0&id=67956438&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67956438"]])

export default __exports__